import type { BuilderMessage } from "./types";

/**
 * Submit paints an Answers confirmed card that stores the park id under
 * `details.pending.questionId`. That transcript entry is the record that the
 * question was answered — stream catch-up and session hydrate must not reopen it.
 */
export function isUserQuestionAnsweredInTranscript(
  messages: readonly BuilderMessage[],
  questionId: string,
): boolean {
  const id = questionId.trim();
  if (!id) return false;
  return messages.some((entry) => {
    if (entry.type !== "user") return false;
    const details = entry.details as
      { kind?: string; pending?: { questionId?: string } } | undefined;
    return details?.kind === "confirmed-answers" && details.pending?.questionId === id;
  });
}
